import { useState } from 'react'
import { uniqueId } from 'lodash'

function useToast() {
	const [toastList, setToastList] = useState([])

	function addToastMessage(message, type, action = null) {
		const id = uniqueId();

		if (toastList.length > 2) {
			toastList.splice(0, 1)
		}

		if (typeof (message) == Object || message instanceof Error) {
			message = message?.message ?? message
		}

		setToastList([...toastList, { id, type, message, action }])
	}

	return {
		toastList,
		setToastList,
		addToastMessage
	}
}

export default useToast
